import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** @module store/TreeNode */
import { request, hooks } from "../util";
import { types, flow, getParentOfType, getRoot, getParent } from "mobx-state-tree";
import $ from "jquery";
import { uuid, getTreeParentById } from "react-aiot";
/**
 * The store holding general data for folders. The properties are read-only.
 *
 * @see React AIOT TreeNode documentation for properties and defaults
 * @class TreeNode
 */

var TreeNode = types.model("RMLTreeNode", {
  id: types.union(types.identifier, types.identifierNumber),
  hash: "",
  className: types.frozen(),
  icon: "folder",
  iconActive: "",
  childNodes: types.optional(types.array(types.late(function () {
    return TreeNode;
  })), []),
  title: types.string,
  count: 0,
  attr: types.optional(types.frozen()),
  isTreeLinkDisabled: false,
  checked: false,
  selected: false,
  $busy: false,
  $busyOrder: false,
  $droppable: true,
  $visible: true,
  $rename: false,
  $create: types.optional(types.frozen()),
  contentCustomOrder: 0,
  forceCustomOrder: false,
  // Content order
  lastOrderBy: "",
  orderAutomatically: false,
  // Subfolder order
  lastSubOrderBy: "",
  subOrderAutomatically: false,
  //searchSelected: false,
  //expandedState: true,
  //displayChildren: true,
  //selectedIds: [],
  //onRenameClose: undefined,
  //onAddClose: undefined,
  //onSelect: undefined,
  //onNodePressF2: undefined,
  //onExpand: undefined,
  //onUlRef: undefined
  properties: types.optional(types.frozen()),
  isQueried: true
}).views(function (self) {
  return {
    get indeterminate() {
      return false; // Not implemented, yet
      //if (self.checked) {
      //    return false;
      //}
      //const allChilds = self.childNodes,
      //    checked = allChilds.filter(o => o.checked).length;
      //return checked > 0;
    },

    get parentArray() {
      return getParent(self);
    },

    get nextSibling() {
      var parentArray = self.parentArray,
          indexOf = parentArray.indexOf(self),
          nextOf = indexOf + 1;
      return indexOf > -1 ? parentArray[nextOf] : undefined;
    },

    get path() {
      var result = [],
          parent = self;

      while (parent) {
        result.push(parent);

        try {
          parent = getParentOfType(parent, TreeNode);
        } catch (e) {
          parent = undefined;
        }
      }

      return result.reverse();
    },

    get parentId() {
      var root = getRoot(self);
      return getTreeParentById(self.id, root.tree, root.rootId);
    }

  };
}).actions(function (self) {
  return {
    /**
     * Update this node attributes.
     *
     * @param {function} callback The callback with one argument (node draft)
     * @param {boolean} [setHash] If true the hash node is changed so a rerender is forced
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     */
    setter: function setter(callback) {
      var setHash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      callback(self);
      setHash && (self.hash = uuid());
    },

    /**
     * Update the checked flag.
     *
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     */
    toggleChecked: function toggleChecked() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !self.checked;
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      self.checked = flag;
      children && self.childNodes.forEach(function (n) {
        return n.toggleChecked(flag);
      }); // Check parents

      if (!flag) {
        var path = self.path;
        path.pop();
        path.forEach(function (n) {
          return n.toggleChecked(false, false);
        });
      }
    },

    /**
     * Rename folder.
     *
     * @param {string} inputValue The new name
     * @returns {object} Server response
     * @throws Error
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     * @async
     */
    setName: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inputValue) {
      var result, id, name, cnt, children, rest;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self.setter(function (node) {
                node.$busy = true;
              });
              _context.prev = 1;
              _context.next = 4;
              return request({
                location: {
                  path: "/folders/" + self.id,
                  method: "PUT"
                },
                request: {
                  name: inputValue
                }
              });

            case 4:
              result = _context.sent;
              id = result.id;
              name = result.name;
              cnt = result.cnt;
              children = result.children;
              rest = _objectWithoutProperties(result, ["id", "name", "cnt", "children"]);
              self.setter(function (node) {
                node.title = name;
                node.properties = $.extend(true, {}, node.properties, rest);
                node.$busy = false;
              });
              return _context.abrupt("return", result);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              self.setter(function (node) {
                node.$busy = false;
              }, self.id);
              throw _context.t0;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    })),

    /**
     * (Pro only) Apply an order to the folder content.
     *
     * @param {string} id The sortable id
     * @param {boolean} [automatically=false] If true the order is applied automatically if new files are added to the folder
     * @returns {boolean}
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     * @async
     */
    applyOrder: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var automatically,
          result,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              automatically = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;

              if (!(process.env.PLUGIN_CTX === "pro")) {
                _context2.next = 19;
                break;
              }

              /* onlypro:start */
              self.setter(function (node) {
                node.$busyOrder = true;
              });
              _context2.prev = 3;
              _context2.next = 6;
              return request({
                location: {
                  path: "/folders/" + self.id + "/content/sortables",
                  method: "POST"
                },
                request: {
                  id: id,
                  automatically: automatically
                }
              });

            case 6:
              result = _context2.sent;

              if (!result) {
                _context2.next = 13;
                break;
              }

              id !== "reindex" && id !== "last" && (self.contentCustomOrder = 1, self.lastOrderBy = id);
              automatically && (self.orderAutomatically = true);
              id === "original" && (self.contentCustomOrder = 0, self.orderAutomatically = false);
              id === "deactivate" && (self.orderAutomatically = false);
              return _context2.abrupt("return", true);

            case 13:
              return _context2.abrupt("return", false);

            case 14:
              _context2.prev = 14;
              self.setter(function (node) {
                node.$busyOrder = false;
              });
              return _context2.finish(14);

            case 17:
              _context2.next = 20;
              break;

            case 19:
              return _context2.abrupt("return", false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3,, 14, 17]]);
    })),

    /**
     * (Pro only) Apply an order to the childrens.
     *
     * @param {string} [id] The sortable id - if not set the childNodes are sorted again by the last local known orderby
     * @param {boolean} [automatically=false] If true the order is applied automatically if new folders are added as subfolders
     * @returns {boolean}
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     * @async
     * @since 4.4
     */
    applyChildrenOrder: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
      var automatically,
          result,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              automatically = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;

              if (!(process.env.PLUGIN_CTX === "pro")) {
                _context3.next = 16;
                break;
              }

              /* onlypro:start */
              id && self.setter(function (node) {
                node.$busyOrder = true;
              });
              _context3.prev = 3;

              if (!id) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return request({
                location: {
                  path: "/folders/" + self.id + "/sortables",
                  method: "POST"
                },
                request: {
                  id: id,
                  automatically: automatically
                }
              });

            case 7:
              result = _context3.sent;

              if (result) {
                id !== "reindex" && id !== "last" && (self.lastSubOrderBy = id);
                automatically && (self.subOrderAutomatically = true);
                id === "original" && (self.lastSubOrderBy = "");
                (id === "deactivate" || id === "original") && (self.subOrderAutomatically = false);
              }

            case 9:
              /**
               * (Pro only) This action is called when subfolders of a folder are successfully
               * ordered by a criterium. You have to implement the .setter() for the new
               * children's order.
               *
               * @event module:util/hooks#folder/children/order/$id
               * @param {TreeNode[]} children The children of this folder, you have to apply .compare() because it is not reloaded from server
               * @param {function} setChildren A function where you pass one argument: childNodes with new sorting
               * @this module:store/TreeNode~TreeNode
               * @since 4.4.0
               */
              hooks.call("folder/children/order/" + (id || self.lastSubOrderBy), [self.childNodes, function (newChildNodes) {
                return self.setter(function (n) {
                  return n.childNodes.replace(newChildNodes);
                }, true);
              }], self);
              return _context3.abrupt("return", true);

            case 11:
              _context3.prev = 11;
              id && self.setter(function (node) {
                node.$busyOrder = false;
              });
              return _context3.finish(11);

            case 14:
              _context3.next = 17;
              break;

            case 16:
              return _context3.abrupt("return", false);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3,, 11, 14]]);
    })),

    /**
     * Toggle the view of this folder.
     *
     * @param boolean state
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     * @since 4.0.9
     */
    visible: function visible(state) {
      self.$visible = state;
    },

    /**
     * Permanently delete folder.
     *
     * @returns {string|int} The parent id
     * @throws Error
     * @memberof module:store/TreeNode~TreeNode
     * @instance
     * @async
     */
    trash: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self.setter(function (node) {
                node.$busy = true;
              });
              _context4.prev = 1;
              _context4.next = 4;
              return request({
                location: {
                  path: "/folders/" + self.id,
                  method: "DELETE"
                }
              });

            case 4:
              self.visible(false);

            case 5:
              _context4.prev = 5;
              self.setter(function (node) {
                node.$busy = false;
              });
              return _context4.finish(5);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1,, 5, 8]]);
    }))
  };
});
export default TreeNode;